import { ObjectContext } from '@context/ItemZoneContext'

export default function findFirstWithoutSubgroups(
  ctx: ObjectContext['centerInfo'],
  val: number[] = [],
  label: string[] = [],
) {
  if (!ctx) return { label, controlledValues: val }
  val.push(ctx[0].idGruposDeTexturas)
  label.push(ctx[0].nombre)
  if (ctx[0].subGrupos && ctx[0].subGrupos.length > 0) {
    findFirstWithoutSubgroups(ctx[0].subGrupos, val, label)
  }
  //   if (!ctx) return []
  //   const firstElement = ctx[0]
  //   if (!firstElement?.idGruposDeTexturas) return val

  //   const controlledValues = [...val, firstElement.idGruposDeTexturas]
  //   findFirstWithoutSubgroups(firstElement.subGrupos, controlledValues)
  return { label, controlledValues: val }
}
